/* eslint-disable angular/file-name,angular/module-name */
require('babel-polyfill');

// CSS files
require('scss/main.scss');

// Initialize the required modules first
require('shared_modules/core/index.js.coffee');
require('shared_modules/common_api/index.coffee');
require('zenclerk_s_modules/zenclerk_s/index.js');

const ZC_CONFIG = require('env');

import * as Sentry from '@sentry/browser';
import { Integrations } from '@sentry/tracing';
import { Angular as AngularIntegration } from '@sentry/integrations';

const enableSentry = !['development', 'test'].includes(ZC_CONFIG.ENV);

if(enableSentry) {
  Sentry.init({
    dsn: ZC_CONFIG.SENTRY_DSN,
    integrations: [
      new AngularIntegration(),
      new Integrations.BrowserTracing({
        tracingOrigins: [
          'localhost',
          'aideal-lite.appier.com',
          'aideal-lite-pre.appier.com',
          'lite-stg.aideal.arepa.appier.co',
        ],
      }),
    ],
    tracesSampleRate: 0.01,
    sendClientReports: false,
    environment: ZC_CONFIG.ENV,
  });
}

if(enableSentry) {
  angular.module('zc', [
    'ngAnimate',
    'ngCookies',
    'ngMessages',
    'ngResource',
    'angular-loading-bar',
    'angular-md5',
    'colorpicker.module',
    'flow',
    'hc.marked',
    'hljs',
    'LocalStorageModule',
    'ngCsv',
    'ngSentry',
    'pascalprecht.translate',
    'ui.bootstrap',
    'ui.bootstrap.dropdown',
    'ui.bootstrap.tooltip',
    'ui.router',
    'zc.commonApi',
    'zc.core',
    'zc.zenclerkS',
  ]);
} else {
  angular.module('zc', [
    'ngAnimate',
    'ngCookies',
    'ngMessages',
    'ngResource',
    'angular-loading-bar',
    'angular-md5',
    'colorpicker.module',
    'flow',
    'hc.marked',
    'hljs',
    'LocalStorageModule',
    'ngCsv',
    'pascalprecht.translate',
    'ui.bootstrap',
    'ui.bootstrap.dropdown',
    'ui.bootstrap.tooltip',
    'ui.router',
    'zc.commonApi',
    'zc.core',
    'zc.zenclerkS',
  ]);
}

// angular-loading-bar options
angular.module('zc').config(cpfLoadingBar);

cpfLoadingBar.$inject = ['cfpLoadingBarProvider'];
function cpfLoadingBar(cfpLoadingBarProvider) {
  // Wait in ms before the loading bar is display
  cfpLoadingBarProvider.latencyThreshold = 300;
  cfpLoadingBarProvider.includeSpinner = false;
}

// NOTE: Copied from zenclerk, but this causes incorrect behavior in AiDeal lite...
// Proper behavior is to always scroll to top (except when going backwards)
//
// disable automatic scrolling to where ui-view changed
// app.value('$anchorScroll', angular.noop)
// Avoid screen move when page transition
angular.module('zc').config(uiScrollViewProviderConfig);

uiScrollViewProviderConfig.$inject = ['$uiViewScrollProvider'];
function uiScrollViewProviderConfig($uiViewScrollProvider) {
  $uiViewScrollProvider.useAnchorScroll();
}

angular.module('zc').config(compileProviderConfig);

compileProviderConfig.$inject = ['$compileProvider'];
function compileProviderConfig($compileProvider) {
  $compileProvider.preAssignBindingsEnabled(true);
}

angular.module('zc').config(qProviderConfig);

qProviderConfig.$inject = ['$qProvider'];
function qProviderConfig($qProvider) {
  $qProvider.errorOnUnhandledRejections(false);
}

// coffee
let moduleReq = require.context('shared_modules', true, /^\.\/(common_api|core)\/.*(?!(index.coffee|index.js.coffee|index.js)$)/);
for(let key of Array.from(moduleReq.keys())) {
  if(!key.match(/\.test(\.js|\.coffee)?$/)) {
    moduleReq(key);
  }
}

moduleReq = require.context('zenclerk_s_modules', true, /^\.\/.*/);
for(let key of Array.from(moduleReq.keys())) {
  if(!key.match(/\.test(\.js)?$/)) {
    moduleReq(key);
  }
}


angular.module('zc').service('afterLoginHandler', afterLoginHandlerService); // eslint-disable-line angular/no-service-method

afterLoginHandlerService.$inject = ['$cookies', '$location', '$q', '$state', '$translate', '$window', 'Environment', 'returnUrl'];
function afterLoginHandlerService($cookies, $location, $q, $state, $translate, $window, Environment, returnUrl) {
  class AfterLoginHandlerService {
    static handle(currentUser, opts) {
      if(opts == null) { opts = {} }
      if(!currentUser) { return false }
      Environment.get()
        .then(env => {
          $cookies.put('__zcs_admin', `user_id=${currentUser.id}`, { path: '/', expires: moment().add(1, 'years').toDate(), secure: (['production', 'preprod', 'staging'].includes(env)) });
        });

      // set lang
      $translate.use(currentUser.lang);
      moment.locale(currentUser.lang);

      let url = returnUrl.get();
      returnUrl.set(null);

      // forceReload option exists, because we want to force zenclerk tag reload
      // after doing login. This is to update cookie segment.
      if(opts.forceReload) {
        if(url) {
          $window.location.replace(url);
        } else {
          $window.location.replace($state.href('zenclerkS.home', {}, { absolute: true }));
        }
      } else if(url) {
        $location.url(url);
      } else {
        $state.go('zenclerkS.home');
      }
      return $q.resolve();
    }
  }
  return AfterLoginHandlerService;
}

angular.module('zc')
  .run(appRunner);


appRunner.$inject = [
  '$http',
  '$location',
  '$rootScope',
  '$state',
  '$window',
  'Analytics',
  'Api',
  'Devise',
  'Page',
  'StateBeforeActionRunner',
  'ZcTag',
  'ZcsOemService',
  'afterLoginHandler',
  'localStorageService',
];
function appRunner(
  $http,
  $location,
  $rootScope,
  $state,
  $window,
  Analytics,
  Api,
  Devise,
  Page,
  StateBeforeActionRunner,
  ZcTag,
  ZcsOemService,
  afterLoginHandler,
  localStorageService,
) {

  Analytics.initializeGA();
  ZcTag.initialize();

  let token = localStorageService.get('zc_token');
  token = localStorageService.cookie.get('auth_token');
  if(token) {
    $http.defaults.headers.common.Authorization = `Bearer ${token}`;
  }

  $rootScope.Page = Page;

  if(_.endsWith($location.host(), window.ZC_CONFIG.MAKEREPEATER_DOMAIN)) { // eslint-disable-line angular/window-service
    // allow makerepeater to access AiDeal lite's dom through iframe
    $window.document.domain = window.ZC_CONFIG.MAKEREPEATER_DOMAIN; // eslint-disable-line angular/window-service
    ZcsOemService.set('makerepeater');
    ZcsOemService.providePublicApi();
    Api.setBasePath(window.ZC_CONFIG.MAKEREPEATER_API_URL); // eslint-disable-line angular/window-service
  }

  StateBeforeActionRunner.initialize();

  const makeRepeaterOrigin = `https://${$window.ZC_CONFIG.MAKEREPEATER_OEM_HOST}`;

  function sendMessageToMakeRepeater(message) {
    $window.parent.postMessage(message, makeRepeaterOrigin);
  }

  sendMessageToMakeRepeater($window.document.body.scrollHeight);

  $window.addEventListener('message', function(event) {
    if(event.origin !== makeRepeaterOrigin) {
      return;
    }

    if(angular.isString(event.data)) {
      if(event.data.startsWith('/')) {
        $location.url(event.data);
        $rootScope.$applyAsync();
      } else if(event.data === 'getHeight') {
        sendMessageToMakeRepeater($window.document.body.scrollHeight);
      }
    }
  });

  const stateChangeStartListener = $rootScope.$on('$stateChangeStart', function(event, toState, toParams) {

    let promise;
    if(!toState) { return }

    const IGNORE_STATES = [
      '404',
      '500',
      'terms_of_service',
      'privacy_policy',
      'signUp',
      'users.agreement',
      'users.invitation.accept',
      'users.resetPassword',
      'users.signUp',
    ];

    if(IGNORE_STATES.indexOf(toState.name) > -1) {
      return;
    }

    if(ZcsOemService.isOemService()) {
      promise = ZcsOemService.handleLogin();
    } else {
      promise = Devise.getCurrentUser();
    }
    return promise.then(function(user) {
      if(!ZcsOemService.isOemService()) {
        $window.document.documentElement.lang = user.lang;
        if(user && !Devise.isMaster() && user.makerepeater_user_id && !user.makerepeater_is_admin) {
          Devise.signOut();
          return;
        }
      }

      if(toState.name.indexOf('zenclerkS') === 0) { return }

      return afterLoginHandler.handle(user);
    }).catch(err => console.error('Catch error changing state', err, toState, toParams));
  });

  const stateChangeSuccessListener = $rootScope.$on('$stateChangeSuccess', function(event, toState, toStateParams, fromState, fromStateParams) {
    if(toState) {
      Analytics.recordPageview($location.url());
    }
  });

  const stateChangeErrorListener = $rootScope.$on('$stateChangeError', function(event, toState, toStateParams, fromState, fromStateParams, errors) {
    console.error('Error changing state', errors, 'FROM', fromState, 'TO', toState, toStateParams);
    if(!Devise.currentUser) {
      $state.go('users.signIn');
    }
  });

  $rootScope.$on('$destroy', () => {
    stateChangeStartListener();
    stateChangeSuccessListener();
    stateChangeErrorListener();
  });
}

// For webpack dev server reloading
if(window.ZC_CONFIG.USE_WEBPACK_DEV_SERVER) { // eslint-disable-line angular/window-service
  $.getScript('/webpack-dev-server.js');
}



// WEBPACK FOOTER //
// ./src/zenclerk_s.js